import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import taskServices from '../taskServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import moment from 'moment/moment';



function TaskForm({data,callBack,projectId }) {

    const {AppAlert} = useAlert();
    const {masters,projectDD,userDD} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {     
        projectId:Number(projectId),
        sequence:0,
        title:"",
        details:"",
        startDate:moment().format(moment.HTML5_FMT.DATE),
        startTime:moment().add(1,"hours").startOf('hour').format(moment.HTML5_FMT.TIME),
        endDate:moment().format(moment.HTML5_FMT.DATE),
        endTime:moment().add(2,"hours").startOf('hour').format(moment.HTML5_FMT.TIME),
        calendarType:"1",
        priority:"1",
        taskStatus:1,
        notify:0,
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            sequence:Number(data.sequence+1),
            projectId:data.projectId,
            title:data.title,
            details:data.details,
            startDate:data.startDate,
            startTime:data.startTime,
            endDate:data.endDate,
            endTime:data.endTime,
            calendarType:data.calendarType,
            priority:data.priority,
            assignedTo:data.assignedTo,
            taskStatus:data.taskStatus,
            notify:0,
            
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        projectId:Yup.string().required("Required"),
        title:Yup.string().required("Required"),
        startDate:Yup.string().required("Required"),
        startTime:Yup.string().required("Required"),
        taskStatus:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        taskServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New Task">
                    <span type="button" className="badge rounded-pill bg-primary p-2" onClick={addNew}><Add style={{fontSize:18}} />Add New Task</span>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Task"}</DialogTitle>
                                    <DialogContent>
                                            <div className='row'>
                                                <div className='col-md-8'>
                                                    <div className="row">
                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="input" formik={formik} type="text" 
                                                                label="Title" name="title" 
                                                            />
                                                        </div>
                                                        {/*
                                                        <div className='col-md-6 my-2'>
                                                            <FormikControl control="autoselect" formik={formik} 
                                                                label="Select Project " name="projectId"  
                                                                options={projectDD} multiple={false} 
                                                            />
                                                        </div>
                                                        */}
                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="input" formik={formik} type="text" multiline={true} rows={4}
                                                                label="Details" name="details" 
                                                            />
                                                        </div>
                                                        <hr/>
                                                        <div className="col-md-6 my-2" >
                                                            <FormikControl control="input" formik={formik} type="date" 
                                                                label="Start Date" name="startDate" 
                                                            />
                                                        </div>
                                                        <div className="col-md-6 my-2" >
                                                            <FormikControl control="input" formik={formik} type="time" 
                                                                label="Start Time" name="startTime" 
                                                            />
                                                        </div>
                                                        <div className="col-md-6 my-2" >
                                                            <FormikControl control="input" formik={formik} type="date" 
                                                                label="End Date" name="endDate" 
                                                            />
                                                        </div>
                                                        <div className="col-md-6 my-2" >
                                                            <FormikControl control="input" formik={formik} type="time" 
                                                                label="End Time" name="endTime" 
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='row'>
                                                        
                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="autoselect" formik={formik}
                                                                options={userDD}
                                                                label="Assigned To" name="assignedTo"
                                                            />
                                                        </div>

                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="autoselect" formik={formik}
                                                                options={masters['task-status']}
                                                                label="Task Status" name="taskStatus"
                                                            />
                                                        </div>
                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="radio" formik={formik}
                                                                options={masters['calendar-type']}
                                                                label="Type" name="calendarType"
                                                            />
                                                        </div>
                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="radio" formik={formik}
                                                                options={masters['priority']}
                                                                label="Priority" name="priority"
                                                            />
                                                        </div>
                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="switch" formik={formik}
                                                                label="Notify" name="notify"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /*  JSON.stringify(formik.values)  */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default TaskForm